export default __webpack_public_path__ + "static/media/santa-cap-left.72e2139e.svg";